var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileMicOff = function SvgMobileMicOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.178 25.17"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1",
    d: "m1.414 1.414 22.349 22.342"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M9.542 9.541v3.041a3.051 3.051 0 0 0 5.2 2.179m.893-4.859V4.457a3.051 3.051 0 0 0-6.036-.588"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4",
    d: "M17.67 17.612a7.1 7.1 0 0 1-12.188-5.026v-2.027m14.214 0v2.026a7.2 7.2 0 0 1-.109 1.251"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 2",
    d: "M12.593 19.696v4.06"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3",
    d: "M8.525 23.756h8.128"
  }))));
};
export default SvgMobileMicOff;